import React from 'react';
import R from 'ramda';
import { ActivateDialog, DeactivateDialog } from '../app/components';
import { connect } from 'react-redux';
import { updatePropertyWithImages } from '../../common/properties/actions';
import Property from './Property';

class MyProperties extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeactivate: false,
      confirmActivate: false,
      statusChangePropertyId: '',
    };
  }

  deactivateProperty = (e, propertyId) => {
    e.preventDefault();
    this.setState({ confirmDeactivate: true, statusChangePropertyId: propertyId });
  }

  activateProperty = (e, propertyId) => {
    e.preventDefault();
    this.setState({ confirmActivate: true, statusChangePropertyId: propertyId });
  }

  render() {
    const { viewer, myProperties, updatePropertyWithImages } = this.props;
    const { confirmDeactivate, confirmActivate, statusChangePropertyId } = this.state;

    return (
      <div className="properties">
        {myProperties.map((property, key) =>
          <Property
            from="/myProperties"
            key={key}
            viewer={viewer}
            property={property}
            presentational={false}
            deactivateProperty={this.deactivateProperty}
            activateProperty={this.activateProperty}
          />,
        )}
        <ActivateDialog
          component={this}
          propertyId={statusChangePropertyId}
          confirmActivate={confirmActivate}
          updatePropertyWithImages={updatePropertyWithImages}
        />
        <DeactivateDialog
          component={this}
          propertyId={statusChangePropertyId}
          confirmDeactivate={confirmDeactivate}
          updatePropertyWithImages={updatePropertyWithImages}
        />
      </div>
    );
  }
}

MyProperties.propTypes = {
  viewer: React.PropTypes.object,
  myProperties: React.PropTypes.array.isRequired,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
    }),
    { updatePropertyWithImages },
  ),
)(MyProperties);



// WEBPACK FOOTER //
// ./src/browser/properties/MyProperties.js